module.exports = __webpack_public_path__ + "img/community.8b9e5540.svg";